<template>
  <div class="container">
    <div class="animated fadeIn">
      <b-alert :variant="dismissibleType"
               dismissible
               :show="showDismissibleAlert"
               @dismissed="showDismissibleAlert=false">
        {{ errMsg }}
      </b-alert>

      <div v-if="hasPermissionToSync && !forceSyncScreenHide">
        <b-row>
          <b-col>
            <b-card>
              <div slot="header">
                <strong>Sync Settings</strong>
              </div>
              <div>
                <div class="d-flex justify-content-between">
                  <button id="btnExpToMDesk" class="btn btn-info ml-3" @click="exportSettingsTomDesking">
                    <i title="Sync To mDesking" class="fa fa-level-up fa-lg text-white"></i>
                    <strong class="text-white">Export To mDesking</strong>
                  </button>
                  <button id="btnImpFromMDesk" class="btn btn-info ml-3" @click="importSettingsFrommDesking">
                    <i title="Sync To mDesking" class="fa fa-level-down fa-lg text-white"></i>
                    <strong class="text-white">Import From mDesking</strong>
                  </button>

                  <button id="btnSettCompare" v-if="isInternalStaff" class="btn btn-info ml-3" @click="settingsDiff">
                    <i title="Settings Diff" class="fa fa-clone fa-lg text-white"></i>
                    <strong class="text-white">Settings Comparison</strong>
                  </button>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col>
          <b-card v-if="hasmDrive">
            <div slot="header" class="d-flex">
              <strong class="mdrive-header-text">mDrive Settings</strong>
              <div class="ml-auto">
                <button id="btnSave" class="btn btn-primary" @click="saveDealerSettings">
                  <i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong>
                </button>

                <button id="btnRefresh" v-if="isInternalStaff" class="btn btn-secondary ml-3" @click="refreshCache">
                  <i title="Refresh" class="fa fa-refresh fa-lg text-white"></i>
                  <strong class="text-white">Refresh</strong>
                </button>
              </div>
            </div>
            <b-row>
              <b-col md="12" md-offset="2">

                <slot v-if="!dealerSettings">
                  <div role="alert" aria-live="polite"><div class="text-center my-2">No mDrive settings loaded yet.</div></div>
                </slot>
                <slot v-if="dealerSettings">
                  <b-row class="my-1">
                    <b-col md="3">Total Cash</b-col>
                    <b-col md="2">
                      <b-form-input id="inpTotalCash" type="number" v-model.number="dealerSettings.Items.MDRIVETOTALCASH.Value"></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row class="my-1">
                    <b-col md="3">Annual Mileage</b-col>
                    <b-col md="2">
                      <b-form-input id="inpAnnualMileage" type="number" v-model.number="dealerSettings.Items.MDRIVEANNUALMILEAGE.Value"></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row class="my-1">
                    <b-col md="3">Payment</b-col>
                    <b-col md="2">From</b-col>
                    <b-col md="2">
                      <b-form-input id="inpPaymentFrom" type="number" v-model.number="dealerSettings.Items.MDRIVEPAYMENTFROM.Value"></b-form-input>
                    </b-col>
                    <b-col md="1">To</b-col>
                    <b-col md="2">
                      <b-form-input id="inpPaymentTo" type="number" v-model.number="dealerSettings.Items.MDRIVEPAYMENTTO.Value"></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row class="my-1">
                    <b-col md="3">Term</b-col>
                    <b-col md="2">From</b-col>
                    <b-col md="2">
                      <b-form-input id="inpTermFrom" type="number" v-model.number="dealerSettings.Items.MDRIVETERMFROM.Value"></b-form-input>
                    </b-col>
                    <b-col md="1">To</b-col>
                    <b-col md="2">
                      <b-form-input id="inpTermTo" type="number" v-model.number="dealerSettings.Items.MDRIVETERMTO.Value"></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row class="my-1">
                    <b-col md="3">Credit Score</b-col>
                    <b-col md="2">
                      <b-form-input id="inpCreditScore" type="number" v-model.number="dealerSettings.Items.MDRIVECREDITSCORE.Value"></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row class="my-1">
                    <b-col md="3">Used car Max Advance % of Dealer Cost</b-col>
                    <b-col md="2">
                      <b-form-input type="number" v-model.number="dealerSettings.Items.MDRIVEUSEDVALUEOVERRIDE.Value"></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row class="my-1">
                    <b-col md="3">Custom Lot Age</b-col>
                    <b-col md="2">
                      <b-form-input id="inpCustomLotAge" v-model.number="dealerSettings.Items.MDRIVELOTAGELABEL.Value"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="my-1">
                    <b-col md="3">Include taxes and registration fees</b-col>
                    <b-col md="2">
                      <c-switch id="inpIncTaxRegFees" size="sm" v-model="boolIncludeTaxAndRegistration" type="text" variant="primary" on="On" off="Off" :pill="true" />
                    </b-col>
                  </b-row>
                  <b-row class="my-1">
                    <b-col md="3">Push To mDesking Button Visible</b-col>
                    <b-col md="2">
                      <c-switch id="inpIncTaxRegFees" size="sm" v-model="boolPushTomDeskingBtnVisible" type="text" variant="primary" on="On" off="Off" :pill="true" />
                    </b-col>
                  </b-row>
                  <hr />
                  <b-row class="my-1">
                    <b-col md="3">
                      Lease Terms <br /> <br />
                      <button class="btn btn-secondary btn-sm" @click="toggleAllLeaseTerms()">Select/Deselect All</button>
                    </b-col>
                    <b-col md="8">
                      <ul id="example-1">
                        <li v-for="(lterm, index) in validLeaseTerms" style="display:inline-block">
                          <input class="form-check-input" type="checkbox" v-model="selectedLeaseTerms[index]" value="" id="flexCheckDefault" style="min-width:20px;padding-right:10px;">
                          <label class="form-check-label" for="flexCheckDefault" style="min-width:20px; padding-right:40px">
                            {{lterm}}
                          </label>
                        </li>
                      </ul>
                    </b-col>
                  </b-row>
                  <hr />
                  <b-row class="my-1">
                    <b-col md="3">
                      Retail Terms <br /> <br />
                      <button class="btn btn-secondary btn-sm" @click="toggleAllRetailTerms()">Select/Deselect All</button>
                    </b-col>
                    <b-col md="8">
                      <ul id="example-1">
                        <li v-for="(lterm, index) in validRetailTerms" style="display:inline-block">
                          <input class="form-check-input" type="checkbox" v-model="selectedRetailTerms[index]" value="" id="flexCheckDefault" style="min-width:20px;padding-right:10px;">
                          <label class="form-check-label" for="flexCheckDefault" style="min-width:20px; padding-right:40px">
                            {{lterm}}
                          </label>
                        </li>
                      </ul>
                    </b-col>
                  </b-row>
                </slot>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <loading :show="boolLoading"
               :label="txtLoading">
      </loading>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import loading from 'vue-full-loading'
  import store from '@/store'
  import cSwitch from '../components/Switch'

  export default {
    components: {
      loading,
      cSwitch
    },
    props: ['forceSyncScreenHide'],
    created() {
      
    this.hasPermissionToSync =( store.state.currentRole == 'Admin')
      this.hasmDrive = !store.state.kioskMode
      this.isInternalStaff = store.state.isInternalStaff
      this.boolLoading = true
      this.boolIncludeTaxAndRegistration = true
      this.boolPushTomDeskingBtnVisible = false
      axios.get('/api/mdrive/getsettings')
        .then(response => {
          //console.log(JSON.stringify(response))
          this.dealerSettings = response.data
          this.boolLoading = false
          if (this.dealerSettings && this.dealerSettings.Items) {
            if (this.dealerSettings.Items.MDRIVELEASETERMS && this.dealerSettings.Items.MDRIVERETAILTERMS) {
              this.loadTerms()
            }
            if (this.dealerSettings.Items.MDRIVEEXCLUDETAXREGFEES) {
              this.boolIncludeTaxAndRegistration = (this.dealerSettings.Items.MDRIVEEXCLUDETAXREGFEES.Value == "0")
            }
            if (this.dealerSettings.Items.MDRIVEPUSHTOMDESKVISIBILITY) {
              this.boolPushTomDeskingBtnVisible = (this.dealerSettings.Items.MDRIVEPUSHTOMDESKVISIBILITY.Value == "1")
            }    
          }
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    data() {
      return {
        errMsg: '',
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        boolLoading: false,
        txtLoading: 'Loading...',
        dealerSettings: null,
        hasPermissionToSync: false,
        hasmDrive: false,
        isInternalStaff: false,
        validLeaseTerms: [12, 15, 18, 21, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 48, 49, 50, 51, 52, 54, 57, 60, 66, 72],
        validRetailTerms: [12, 18, 24, 30, 36, 42, 48, 54, 60, 63, 66, 72, 75, 78, 84, 88, 90, 96],
        selectedLeaseTerms: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        selectedRetailTerms: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        selectAllLeaseTermsSwitch: false,
        selectAllRetailTermsSwitch: false

      }
    },
    methods: {
      saveDealerSettings() {
        var self = this
        if (!self.dealerSettings) {
          self.errMsg = 'Data missing.'
          self.showDismissibleAlert = true
          return
        }

        //console.log(JSON.stringify(self.dealerSettings));
        if (this.dealerSettings.Items && this.dealerSettings.Items.MDRIVEEXCLUDETAXREGFEES) {
          this.dealerSettings.Items.MDRIVEEXCLUDETAXREGFEES.Value  = this.boolIncludeTaxAndRegistration ? 0: 1
        }

        if (this.dealerSettings.Items && this.dealerSettings.Items.MDRIVEPUSHTOMDESKVISIBILITY) {
          this.dealerSettings.Items.MDRIVEPUSHTOMDESKVISIBILITY.Value  = this.boolPushTomDeskingBtnVisible ? 1 : 2
        }

        if (this.dealerSettings.Items && this.dealerSettings.Items.MDRIVELEASETERMS && this.dealerSettings.Items.MDRIVERETAILTERMS) {
          this.prepTerms()
        }

        this.$validator.validateAll().then((result) => {
          if (result) {
            self.boolLoading = true
            var data = {
            'data': self.dealerSettings.Items
          }
            axios.post('/api/mdrive/savesettings', data)
              .then(response => {
                self.errMsg = 'Settings Saved.  The changes of the terms will affect next mDrive calculations which are done nightly.'
                self.dismissibleType = 'success'
                self.showDismissibleAlert = true
                self.boolLoading = false
                 this.$emit('clicked', 'true')
              })
              .catch(error => {
                self.SetErrorMsg(error, 'saving')
              })
          }
        })
      },
      loadTerms() {
        let self = this
        let leaseTerms = self.dealerSettings.Items.MDRIVELEASETERMS.Value
        let retailTerms = self.dealerSettings.Items.MDRIVERETAILTERMS.Value
        if (leaseTerms) {
          leaseTerms.split(',').map(x => +x).forEach(t => {
            let idx = self.validLeaseTerms.indexOf(t)
            if (idx != -1) {
              self.selectedLeaseTerms[idx] = 1
            }
          })
        }
        if (retailTerms) {
          retailTerms.split(',').map(x => +x).forEach(t => {
            let idx = self.validRetailTerms.indexOf(t)
            if (idx != -1) {
              self.selectedRetailTerms[idx] = 1
            }
          })
        }
      },
      prepTerms() {
        let self = this
        let idx = 0
        let leaseTermsString = ""
        let retailTermsString = ""
        self.selectedLeaseTerms.forEach(lt => {
          if (lt) {
            leaseTermsString += self.validLeaseTerms[idx].toString()
            leaseTermsString += ","
          }
          idx = idx + 1
        })
        if (leaseTermsString.length > 0) {
          self.dealerSettings.Items.MDRIVELEASETERMS.Value = leaseTermsString.substring(0, leaseTermsString.length - 1)
        }  else {
          self.dealerSettings.Items.MDRIVELEASETERMS.Value = leaseTermsString
        }

        idx = 0
        self.selectedRetailTerms.forEach(rt => {
          if (rt) {
            retailTermsString += self.validRetailTerms[idx].toString()
            retailTermsString += ","
          }
          idx = idx + 1
        })
        if (retailTermsString.length > 0) {
          self.dealerSettings.Items.MDRIVERETAILTERMS.Value = retailTermsString.substring(0, retailTermsString.length - 1)
        } else {
          self.dealerSettings.Items.MDRIVERETAILTERMS.Value = retailTermsString
        }
      },
      toggleAllLeaseTerms() {
        let self = this
        self.selectAllLeaseTermsSwitch = !self.selectAllLeaseTermsSwitch
        if (self.selectAllLeaseTermsSwitch) {
          self.selectedLeaseTerms = self.selectedLeaseTerms.map(t => (t * 0) + 1)
        }
        else {
          self.selectedLeaseTerms = self.selectedLeaseTerms.map(t => (t * 0))
        }
      },
      toggleAllRetailTerms() {
        let self = this
        self.selectAllRetailTermsSwitch = !self.selectAllRetailTermsSwitch
        if (self.selectAllRetailTermsSwitch) {
          self.selectedRetailTerms = self.selectedRetailTerms.map(t => (t * 0) + 1)
        }
        else {
          self.selectedRetailTerms = self.selectedRetailTerms.map(t => (t * 0))
        }
      },
      exportSettingsTomDesking() {
        let self = this
        let message = 'Are you sure you would like to export settings?'
        let options = {
          html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'Continue',
          cancelText: 'Close',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'soft', // 'basic', // coming soon: 'soft', 'hard'
          verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
          verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
          clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: '' // Custom class to be injected into the parent node for the current dialog instance
        }

      self.$dialog.confirm(message, options)
        .then(function () {
          self.boolLoading = true
          axios.post('/api/settings/exporttomdesking', null)
            .then(response => {
              self.errMsg = 'Settings Exported'
              self.dismissibleType = 'success'
              self.showDismissibleAlert = true
              self.boolLoading = false
            })
            .catch(error => {
              self.SetErrorMsg(error, 'exporting')
            })
        })
        .catch(function () {

        })
    },
    importSettingsFrommDesking () {
      var self = this
      let message = 'Are you sure you would like to import settings?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'soft', // 'basic', // coming soon: 'soft', 'hard'
        verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      }

      self.$dialog.confirm(message, options)
        .then(function () {
          self.boolLoading = true
          axios.post('/api/settings/importtomdesking', null)
            .then(response => {
              self.errMsg = 'Settings Imported'
              self.dismissibleType = 'success'
              self.showDismissibleAlert = true
              self.boolLoading = false
            })
            .catch(error => {
              self.SetErrorMsg(error, 'importing')
            })
        })
        .catch(function () {

        })
    },
    SetErrorMsg (error, action) {
      var self = this

      if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { self.$router.push('/login') }

      self.boolLoading = false

      self.errMsg = 'There was an error ' + action + ' your changes : '
      if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
        self.errMsg = self.errMsg + error.response.statusText
      } else {
        self.errMsg = self.errMsg + error
      }

      self.dismissibleType = 'danger'
      self.showDismissibleAlert = true

      if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { self.errMsg = error.response.statusText.replace('403.1', '') }
    },
    refreshCache () {
      var self = this
      var data = {
        'refresh': true
      }
      axios.post('/api/mdrive/getsettings', data)
        .then(response => {
          self.dealerSettings = response.data
          self.boolLoading = false
        })
        .catch(error => {
          self.SetErrorMsg(error, 'refreshing')
        })
    },
    settingsDiff () {
      this.$router.push('/SettingsDifferences')
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>

<style scoped>
  body {
    background-color: #e4e5e6;
  }
    .container {

    position: relative;
    float: left;
}

  .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /* Card Header */

  .card-header {
    padding: 1.25rem calc(1.25rem + 15px) !important;
  }

  .mdrive-header-text {
    line-height: 35px;
  }

  #btnSave {
    /* border-radius: .25rem !important; */
    margin-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/DealerSettings.vue